import { createContext } from "react";
import { AuthOptions, AuthType, EmbeddedSearchWidget } from "./types";
import type { Options } from "@gleanwork/web-sdk";

// These base, search, and box options contain playground-specific overrides.
// Omitted options use the selected SDK's runtime defaults.
const baseOptions: Options & Record<string, unknown> = {
    enableActivityLogging: true,
}

const boxOptions = {
    boxShadow: 'none',
}

export const baseOptionsKey = 'Options';
export const searchOptionsKey = 'Search Options';
export const authOptionsKey = 'Auth Options';
export const sdkOptionsKey = 'SDK Options';

const useNpm = new URLSearchParams(location.search).has('useNpm')

export const defaultConfig = {
    [sdkOptionsKey]: {
        source: useNpm ? 'npm' : "https://canary.glean.com/glean-web-sdk-latest.min.js",
        integrity: ""
    },
    [authOptionsKey]: {
        type: AuthType.Default,
    } as AuthOptions,
    [baseOptionsKey]: baseOptions,
    [searchOptionsKey]: {} as Record<string, unknown>,
    [EmbeddedSearchWidget.SearchBox]: {
        autofocus: true,
        searchBoxCustomizations: {
            ...boxOptions,
            borderRadius: 24,
            placeholderText: "Search for anything...",
        },
    },
    [EmbeddedSearchWidget.SearchResults]: {
        hideDatasourceFilter: false,
        hideTopBarFilters: false,
        showAutocompleteContent: false,
        showHomePageContent: false,
        showInlineSearchBox: false,
    } as Record<string, unknown>,
    [EmbeddedSearchWidget.Chat]: {} as Record<string, unknown>,
}

export type ConfigType = typeof defaultConfig;

const defaultContext = {
    config: defaultConfig,
    setConfig: (config: ConfigType) => {},
}

export const EmbedConfigContext = createContext(defaultContext);